// frontend/src/components/Auth/ForgotPassword.jsx
// 忘記密碼表單組件

import { useState } from 'react';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { Box, TextField, Button, Typography, Alert, Link, CircularProgress } from '@mui/material';
import { Email as EmailIcon, ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import authService from '../../services/authService';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await authService.forgotPassword(email);
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.message || '請求失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <Box>
        <Alert severity="success" sx={{ mb: 3 }}>
          如果此電子郵件已註冊，您將收到密碼重設郵件。
          <br />
          請檢查您的信箱（包含垃圾郵件資料夾）。
        </Alert>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          沒有收到郵件？請確認：
        </Typography>
        <Box component="ul" sx={{ pl: 2, color: 'text.secondary', fontSize: '0.875rem' }}>
          <li>輸入的電子郵件地址正確</li>
          <li>檢查垃圾郵件資料夾</li>
          <li>等待幾分鐘後再次嘗試</li>
        </Box>
        <Button
          fullWidth
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate('/login')}
          sx={{ mt: 3 }}
        >
          返回登入
        </Button>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h5" component="h2" gutterBottom sx={{ mb: 1 }}>
        忘記密碼
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        請輸入您註冊時使用的電子郵件地址，我們將發送密碼重設連結給您。
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Box component="form" onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label="電子郵件"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          disabled={loading}
          autoComplete="email"
          autoFocus
          InputProps={{
            startAdornment: <EmailIcon color="action" sx={{ mr: 1 }} />,
          }}
          sx={{ mb: 3 }}
        />

        <Button
          type="submit"
          fullWidth
          variant="contained"
          disabled={loading || !email}
          sx={{
            py: 1.5,
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            '&:hover': {
              background: 'linear-gradient(135deg, #5a6fd6 0%, #6a4190 100%)',
            },
          }}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : '發送重設郵件'}
        </Button>

        <Box sx={{ mt: 3, textAlign: 'center' }}>
          <Link
            component={RouterLink}
            to="/login"
            variant="body2"
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              textDecoration: 'none',
            }}
          >
            <ArrowBackIcon fontSize="small" sx={{ mr: 0.5 }} />
            返回登入
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

export default ForgotPassword;
